<div class="notification" [ngClass]="{ 'success': type === 'success', 'error': type === 'error' }">
    <em *ngIf="type === 'error'" class="fa-solid fa-triangle-exclamation me-2"></em>
    <em *ngIf="type === 'success'" class="fa-solid fa-check me-2"></em>
    <em *ngIf="type === 'notification'" class="fa-solid fa-info-circle me-2"></em> {{ message }}
</div>